import { renderless, api } from "@opentiny/vue-renderless/button-group/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import Popover from "@opentiny/vue-popover";
import Button from "@opentiny/vue-button";
import { iconPopup, iconWriting } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  emits: ["change", "edit", "update:modelValue"],
  props: [].concat(props, ["size", "data", "plain", "modelValue", "disabled", "valueField", "textField", "showMore", "showEdit", "border"]),
  components: {
    TinyPopover: Popover,
    TinyButton: Button,
    IconPopup: iconPopup(),
    IconWriting: iconWriting()
  },
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "tiny-button-group",
    class: [_vm.size ? "tiny-button-group--" + _vm.size : "", _vm.border ? "" : "tiny-button-group--borderless"]
  }, [_vm._t("default", function() {
    return [!(_vm.showMore && _vm.showMore > 0) ? _c("ul", {
      staticClass: "tiny-group-item"
    }, _vm._l(_vm.data, function(node, index) {
      return _c("li", {
        key: index,
        class: {
          active: _vm.state.value === node[_vm.valueField]
        }
      }, [_c("button", {
        class: _vm.getItemClass(node),
        style: {
          height: _vm.size === "medium" ? "42px" : _vm.size === "small" ? "32px" : _vm.size === "mini" ? "24px" : "",
          "line-height": _vm.size === "medium" ? "40px" : _vm.size === "small" ? "30px" : _vm.size === "mini" ? "22px" : ""
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.handleClick(node);
          }
        }
      }, [_vm._v(" " + _vm._s(node[_vm.textField]) + " ")]), node.sup ? _c("span", {
        class: ["tiny-group-item__sup", {
          "tiny-group-item__sup-text": !node.sup.slot && !node.sup.icon && node.sup.text,
          "tiny-group-item__sup-icon": !node.sup.slot && node.sup.icon
        }, typeof node.sup.class === "string" ? node.sup.class : ""].concat(Array.isArray(node.sup.class) ? node.sup.class : [])
      }, [node.sup.slot ? _vm._t(node.sup.slot, null, {
        "sup": node.sup
      }) : node.sup.icon ? _c(node.sup.icon, {
        tag: "component"
      }) : node.sup.text ? _c("span", [_vm._v(_vm._s(node.sup.text))]) : _vm._e()], 2) : _vm._e()]);
    }), 0) : _c("ul", {
      staticClass: "tiny-group-item show-more"
    }, [_vm._l(_vm.state.buttonData, function(node, index) {
      return _c("li", {
        key: index,
        class: {
          active: _vm.state.value === node[_vm.valueField]
        }
      }, [_c("tiny-button", {
        class: _vm.getItemClass(node),
        on: {
          "click": function click($event) {
            return _vm.handleClick(node);
          }
        }
      }, [_vm._v(" " + _vm._s(node[_vm.textField]) + " ")]), node.sup ? _c("span", {
        class: ["tiny-group-item__sup", {
          "tiny-group-item__sup-text": !node.sup.slot && !node.sup.icon && node.sup.text,
          "tiny-group-item__sup-icon": !node.sup.slot && node.sup.icon
        }, typeof node.sup.class === "string" ? node.sup.class : ""].concat(Array.isArray(node.sup.class) ? node.sup.class : [])
      }, [node.sup.slot ? _vm._t(node.sup.slot, null, {
        "sup": node.sup
      }) : node.sup.icon ? _c(node.sup.icon, {
        tag: "component"
      }) : node.sup.text ? _c("span", [_vm._v(_vm._s(node.sup.text))]) : _vm._e()], 2) : _vm._e()], 1);
    }), _vm.data.length > _vm.showMore ? _c("li", {
      staticClass: "tiny-group-item__more"
    }, [_c("tiny-popover", {
      attrs: {
        "visible-arrow": false,
        "width": "200",
        "popper-class": "tiny-group-item__more-popover"
      },
      scopedSlots: _vm._u([{
        key: "reference",
        fn: function fn() {
          return [_c("tiny-button", {
            staticClass: "more-button"
          }, [_c("icon-popup")], 1)];
        },
        proxy: true
      }], null, false, 2157375964)
    }, [_c("ul", {
      staticClass: "more-list"
    }, _vm._l(_vm.state.moreData, function(moreNode, index) {
      return _c("li", {
        key: index,
        class: {
          active: _vm.state.value === moreNode[_vm.valueField],
          "more-item": true
        },
        on: {
          "click": function click($event) {
            return _vm.moreNodeClick(moreNode);
          }
        }
      }, [_vm._v(" " + _vm._s(moreNode[_vm.textField]) + " ")]);
    }), 0)])], 1) : _vm._e(), _vm.showEdit ? _c("li", {
      staticClass: "tiny-group-item__edit"
    }, [_c("tiny-button", {
      staticClass: "edit-button",
      on: {
        "click": function click($event) {
          return _vm.$emit("edit");
        }
      }
    }, [_c("icon-writing")], 1)], 1) : _vm._e()], 2)];
  })], 2);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var pc = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  pc as default
};
